import { createActions, createReducer } from 'reduxsauce'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    setAdministracaoConsultaDespesasCartaoCorporativo: ['administracao'],
    setExercicioConsultaDespesasCartaoCorporativo: ['exercicio'],
    setPeriodoUtilizacaoInicialConsultaDespesasCartaoCorporativo: ['periodoUtilizacaoInicial'],
    setPeriodoUtilizacaoFinalConsultaDespesasCartaoCorporativo: ['periodoUtilizacaoFinal'],
    setNomeConsultaDespesasCartaoCorporativo: ['nome'],
    setCpfConsultaDespesasCartaoCorporativo: ['cpf'],
    setCnpjConsultaDespesasCartaoCorporativo: ['cnpj'],
    limpaFiltroConsultaDespesasCartaoCorporativo: [],
    receberFiltroConsultaDespesasCartaoCorporativo: ['filtroRecebido'],
    setStatusConsultaDespesasCartaoCorporativo: ['status'],
})

const INITIAL_STATE = {
    administracao: '',
    exercicio: { value: new Date().getFullYear(), label: new Date().getFullYear() },
    periodoUtilizacaoInicial: '',
    periodoUtilizacaoFinal: '',
    nome: '',
    cpf: '',
    cnpj: '',
    status: { label: '', value: '' },
}

const setAdministracao = (state = INITIAL_STATE, action) => {
    return { ...state, administracao: action.administracao }
}

const setExercicio = (state = INITIAL_STATE, action) => {
    return { ...state, exercicio: action.exercicio }
}

const setPeriodoUtilizacaoInicial = (state = INITIAL_STATE, action) => {
    return { ...state, periodoUtilizacaoInicial: action.periodoUtilizacaoInicial }
}
const setPeriodoUtilizacaoFinal = (state = INITIAL_STATE, action) => {
    return { ...state, periodoUtilizacaoFinal: action.periodoUtilizacaoFinal }
}

const setNome = (state = INITIAL_STATE, action) => {
    return { ...state, nome: action.nome }
}

const setCpf = (state = INITIAL_STATE, action) => {
    return { ...state, cpf: action.cpf }
}

const setCnpj = (state = INITIAL_STATE, action) => {
    return { ...state, cnpj: action.cnpj }
}

const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const receberFiltro = (state = INITIAL_STATE, action) => {
    return action.filtroRecebido
}

const setStatus = (state = INITIAL_STATE, action) => {
    return { ...state, status: action.status }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.SET_ADMINISTRACAO_CONSULTA_DESPESAS_CARTAO_CORPORATIVO]: setAdministracao,
    [Types.SET_EXERCICIO_CONSULTA_DESPESAS_CARTAO_CORPORATIVO]: setExercicio,
    [Types.SET_PERIODO_UTILIZACAO_INICIAL_CONSULTA_DESPESAS_CARTAO_CORPORATIVO]: setPeriodoUtilizacaoInicial,
    [Types.SET_PERIODO_UTILIZACAO_FINAL_CONSULTA_DESPESAS_CARTAO_CORPORATIVO]: setPeriodoUtilizacaoFinal,
    [Types.SET_NOME_CONSULTA_DESPESAS_CARTAO_CORPORATIVO]: setNome,
    [Types.SET_CPF_CONSULTA_DESPESAS_CARTAO_CORPORATIVO]: setCpf,
    [Types.SET_CNPJ_CONSULTA_DESPESAS_CARTAO_CORPORATIVO]: setCnpj,
    [Types.LIMPA_FILTRO_CONSULTA_DESPESAS_CARTAO_CORPORATIVO]: limpaFiltro,
    [Types.RECEBER_FILTRO_CONSULTA_DESPESAS_CARTAO_CORPORATIVO]: receberFiltro,
    [Types.SET_STATUS_CONSULTA_DESPESAS_CARTAO_CORPORATIVO]: setStatus,
})
